import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { HomepageBanner } from '../components/Banner/homepage-banner'
import type { HomepageBannerProps } from '../types/homepageBanner'

export const mount: MountWithRootOptions<HomepageBannerProps> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<HomepageBanner {...renderProps} />, rootElement, rootOptions)
}
